// defaultPage

// ETC
const ContactUs = () => import(/* webpackChunkName: "ContactUs" */ '../views/ContactUs')
const TNC = () => import(/* webpackChunkName: "TNC" */ '../views/TNC')
const AboutUs = () => import(/* webpackChunkName: "AboutUs" */ '../views/AboutUs')
const PartnerUp = () => import(/* webpackChunkName: "PartnerUp" */ '../views/PartnerUp')

// Hijack Tools
const Hijack = () => import(/* webpackChunkName: "Hijack" */ '../views/Hijack')

// ETC
const page404 = () => import(/* webpackChunkName: "page404" */ '../views/State/404')
const page403 = () => import(/* webpackChunkName: "page403" */ '../views/State/403')
const page500 = () => import(/* webpackChunkName: "page500" */ '../views/State/500')
const pageComingSoon = () => import(/* webpackChunkName: "page500" */ '../views/State/ComingSoon')

//Pertamina
const PertaminaForm = () => import('../views/Pertamina/Form')

//Media Library
const MediaLibrary = () => import(/* webpackChunkName: "MediaLibrary" */ '../views/MediaLibrary')


const defaultPage = [
    {
      path: '/contact-us',
      name: 'contactus',
      component: ContactUs
    },
    {
      path: '/terms-of-service',
      name: 'tos',
      component: TNC
    },
    {
      path: '/partner-up',
      name: 'partnerup',
      component: PartnerUp
    },
    {
      path: '/about-us',
      name: 'aboutus',
      component: AboutUs
    },
    {
      path: '/hijack/:email',
      name: 'hijack',
      component: Hijack,
      meta: { isSuperuser: true }
    },
    {
      path: '/404',
      name: '404',
      component: page404
    },
    {
      path: '/coming-soon',
      name: 'comingsoon',
      component: pageComingSoon
    },
    {
      path: '/403',
      name: '403',
      component: page403
    },
    {
      path: '/500',
      name: '500',
      component: page500
    },
    {
      path: '/pertamina',
      name: 'pertaminaform',
      component: PertaminaForm,
      meta: { isPertamina: true },
    },
    {
      path: '/media-library',
      name: 'medialibrary',
      component: MediaLibrary,
      meta: { requiresAuth: true }
    },
]

export default defaultPage;
